import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const ScenesList = ({ scenes, filmId }) => {
  const location = useLocation();
  const path = location.pathname;
  var lastSlashLocation = path.lastIndexOf("/");

  const getPage = (path) => {
    if (path.endsWith("scenes") || path.endsWith("order") || path.endsWith("script-days") || path.endsWith("storyboard")) {
      return "/edit";
    } else if (path.includes("/shots/")) {
      return "/shots/overview";
    } else {
      return path.substring(lastSlashLocation)
    }
  }
  const page = getPage(path);

  return (
    <aside className="menu">
      <p className="menu-label">Scenes</p>
      <ul className="menu-list">
        <NavLink
          to={`/films/${filmId}/scenes/script-days`}
          activeClassName="is-active"
          isActive={(match, location) => {
            return location.pathname.startsWith(
              `/films/${filmId}/scenes/script-days`
            );
          }}
        >
          Script Days
        </NavLink>
        <NavLink
          to={`/films/${filmId}/scenes/order`}
          activeClassName="is-active"
          isActive={(match, location) => {
            return location.pathname.startsWith(
              `/films/${filmId}/scenes/order`
            );
          }}
        >
          Order
        </NavLink>
        <NavLink
          to={`/films/${filmId}/scenes/storyboard`}
          activeClassName="is-active"
          isActive={(match, location) => {
            return location.pathname.startsWith(
              `/films/${filmId}/scenes/storyboard`
            );
          }}
        >
          Storyboard
        </NavLink>
      </ul>
      <hr />
      <ul className="menu-list" style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: '8px', rowGap: 0 }}>
        {(scenes || []).map((scene, idx) => {
          return (
            <li key={idx} style={{ display: 'contents' }}>
              <NavLink
                to={`/films/${filmId}/scenes/${scene.id}${page}`}
                activeClassName="is-active"
                title={scene.number + ". " + scene.settingName}
                style={{ gridColumn: '1 / 3', display: 'grid', gridTemplateColumns: 'subgrid' }}
                isActive={(match, location) => {
                  return location.pathname.startsWith(
                    `/films/${filmId}/scenes/${scene.id}/`
                  );
                }}
              >
                <span style={{ gridColumn: '1' }}>
                  {scene.number}
                </span>
                <span style={{ gridColumn: '2', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {scene.settingName}
                </span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default ScenesList;
